
    import { defineComponent, type PropType } from 'vue'

    import type { Ad } from '@/common/models/data/dashboard/ads'

    import AdItem from '@/app/views/home/components/AdItem.vue'

    export default defineComponent({
        components: {
            AdItem
        },
        props: {
            ads: {
                type: Array as PropType<Array<Ad>>,
                required: true
            },
            maxCount: {
                type: Number,
                default: 4
            }
        },
        setup (props) {
            const getAdForPosition = (position: number): Ad | undefined => {
                return props.ads.find(ad => ad.position === position)
            }

            return {
                getAdForPosition
            }
        }
    })
